const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const GA_SCRIPT_ID = 'ga4-script';

const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

const isAnalyticsEnabled = () => isBrowser && Boolean(GA_MEASUREMENT_ID);

const ensureGtag = () => {
  if (!isBrowser) return null;

  window.dataLayer = window.dataLayer || [];

  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  return window.gtag;
};

export const initAnalytics = () => {
  if (!isAnalyticsEnabled()) return;

  if (!document.getElementById(GA_SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = GA_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }

  const gtag = ensureGtag();
  if (!gtag || window.__gaInitialized) return;

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false
  });

  window.__gaInitialized = true;
};

export const trackEvent = (eventName, params = {}) => {
  if (!isAnalyticsEnabled()) return;

  const gtag = ensureGtag();
  if (!gtag) return;

  gtag('event', eventName, params);
};

export const trackPageView = ({ path, title, location }) => {
  trackEvent('page_view', {
    page_path: path,
    page_title: title,
    page_location: location
  });
};

export const trackNavigationClick = ({ label, href, menuLocation }) => {
  trackEvent('navigation_click', {
    link_text: label,
    link_url: href,
    menu_location: menuLocation
  });
};

export const trackBookCallClick = ({ source, href, placement }) => {
  trackEvent('book_call_click', {
    cta_source: source,
    link_url: href,
    placement
  });
};

export const hasAnalyticsEnabled = () => Boolean(GA_MEASUREMENT_ID);
